/*
  Pantalla que ve un estudiante cuando su prueba gratis de 7 dias (o su
  plan pago) ya vencio y todavia no ha renovado. En vez de dejarlo entrar
  al Dashboard, App.js lo manda aqui: solo puede elegir un plan nuevo o
  cerrar sesion.
*/
export default function PlanVencido({ onElegirPlan, onCerrarSesion }) {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(145deg, #0a1628 0%, #0f2347 40%, #1a1248 70%, #0d1f3c 100%)',
      fontFamily: 'system-ui, sans-serif',
      padding: 20
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 20,
        padding: '48px 40px',
        textAlign: 'center',
        maxWidth: 420,
        width: '90%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        <div style={{ fontSize: 56, marginBottom: 16 }}>⏰</div>
        <h1 style={{ fontSize: 21, fontWeight: 800, color: '#1B3A8C', marginBottom: 10 }}>
          Tu prueba o tu plan ya vencieron
        </h1>
        <p style={{ fontSize: 14, color: '#6B7280', marginBottom: 28, lineHeight: 1.6 }}>
          Elige un plan para seguir con tus clases, retos y todo el contenido de EspañolGo.
        </p>
        <button onClick={onElegirPlan}
          style={{ width: '100%', padding: '14px', background: 'linear-gradient(135deg, #1B3A8C, #2D5BE3)', color: '#fff', border: 'none', borderRadius: 12, fontSize: 15, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', marginBottom: 12 }}>
          Ver planes
        </button>
        <button onClick={onCerrarSesion}
          style={{ width: '100%', padding: '13px', background: 'transparent', color: '#6B7280', border: '1.5px solid #E2E6F0', borderRadius: 12, fontSize: 14, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>
          Cerrar sesión
        </button>
      </div>
    </div>
  )
}
